module.exports = __webpack_public_path__ + "static/media/badge_level_6_1.1af5d5c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_level_6_1.png
// module id = 492
// module chunks = 0